<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newPaytMeth">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newPaytMeth">Create New Payment Method</v-toolbar-title>
          <v-toolbar-title v-else>Edit Payment Method</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newPaytMeth">
                <v-text-field
                  v-model="paytMethForm.paytmeth"
                  :label="labels.paytmeth"
                  :error-messages="errors.collect('paytmeth')"
                  data-vv-name="paytmeth"
                  :data-vv-as="labels.paytmeth"
                  v-validate="'required|param|max:4'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.paytmeth }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.paytmeth }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="paytMethForm.paytmethDesc"
                  :label="labels.paytmethDesc"
                  :error-messages="errors.collect('paytmethDesc')"
                  data-vv-name="paytmethDesc"
                  :data-vv-as="labels.paytmethDesc"
                  v-validate="'required|entry|max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.capCrcdGiro"
                  :items="capCrcdGiroList"
                  v-model="paytMethForm.capCrcdGiro"
                  item-text="label"
                  item-value="value"
                  data-vv-name="capCrcdGiro"
                  :data-vv-as="labels.capCrcdGiro"
                  :error-messages="errors.collect('capCrcdGiro')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.payChqNo"
                  :items="payChqNoList"
                  v-model="paytMethForm.payChqNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="payChqNo"
                  :data-vv-as="labels.payChqNo"
                  :error-messages="errors.collect('payChqNo')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.drawName"
                  :items="payChqNoList"
                  v-model="paytMethForm.drawName"
                  item-text="label"
                  item-value="value"
                  data-vv-name="drawName"
                  :data-vv-as="labels.drawName"
                  :error-messages="errors.collect('drawName')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.crcdNo"
                  :items="payChqNoList"
                  v-model="paytMethForm.crcdNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="crcdNo"
                  :data-vv-as="labels.crcdNo"
                  :error-messages="errors.collect('crcdNo')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.payBank"
                  :items="payChqNoList"
                  v-model="paytMethForm.payBank"
                  item-text="label"
                  item-value="value"
                  data-vv-name="payBank"
                  :data-vv-as="labels.payBank"
                  :error-messages="errors.collect('payBank')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="paytMethForm.defPayBankDesc"
                  :label="labels.defPayBank"
                  :error-messages="errors.collect('defPayBankDesc')"
                  data-vv-name="defPayBankDesc"
                  :data-vv-as="labels.defPayBankDesc"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('defPayBankList')"
                  v-validate="'max:8'"
                  @change="doDefPayBank"
                  persistent-hint
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <!--lcd_20201210-->
                <v-checkbox
                  v-model="paytMethForm.rtnRen"
                  :label="labels.rtnRen"
                  :error-messages="errors.collect('rtnRen')"
                  data-vv-name="rtnRen"
                  :data-vv-as="labels.rtnRen"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  v-model="paytMethForm.rtnEndt"
                  :label="labels.rtnEndt"
                  :error-messages="errors.collect('rtnEndt')"
                  data-vv-name="rtnEndt"
                  :data-vv-as="labels.rtnEndt"
                ></v-checkbox>
              </v-flex>
              <!--end lcd_20201210-->
              <v-flex xs6>
                <v-checkbox
                  v-model="paytMethForm.genCdPayt"
                  :label="labels.genCdPayt"
                  :error-messages="errors.collect('genCdPayt')"
                  data-vv-name="genCdPayt"
                  :data-vv-as="labels.genCdPayt"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs6> AR: Commented as per OS-154
                <v-checkbox v-model="paytMethForm.autoExtCvr" :label="labels.autoExtCvr" :error-messages="errors.collect('autoExtCvr')" data-vv-name="autoExtCvr" :data-vv-as="labels.autoExtCvr"></v-checkbox>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(paytMethForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newPaytMeth">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(paytMethForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
          <span>Cancel</span>
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
          {{ newPaytMeth ? 'Save Payment Method' : 'Save Payment Method' }}
          <v-icon right>{{ newPaytMeth ? 'mdi-content-save' : 'mdi-content-save' }} </v-icon>
        </v-btn>
      </v-card>
      <v-dialog v-model="helpList" width="900px" persistent>
        <help-list :helpListID="helpListID" @close="doClose" @doAssign="doAssign($event)"></help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import HelpList from './HelpList'
export default {
  data() {
    return {
      labels: {
        // General
        paytmeth: 'Payment Method',
        paytmethDesc: 'Description',
        capCrcdGiro: 'Capture Card/GIRO Details',
        payChqNo: 'Payment Cheque No.',
        drawName: 'Drawer’s Name',
        crcdNo: 'Credit Card No.',
        payBank: 'Payment Bank',
        defPayBank: 'Default Payment Bank',
        genCdPayt: 'Generate Card Payment',
        autoExtCvr: 'Auto Extend Cover',
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date',
        rtnRen: 'Retain on Renewal', // lcd_20201210
        rtnEndt: 'Retain on Endorsement' // lcd_20201210
      },
      paytMethForm: {
        // General
        paytmeth: null,
        paytmethDesc: null,
        capCrcdGiro: 'NA',
        payChqNo: 'N',
        drawName: 'N',
        crcdNo: 'N',
        payBank: 'N',
        defPayBank: null,
        defPayBankDesc: null,
        genCdPayt: false,
        autoExtCvr: false,
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedName: null,
        modifiedDate: null,
        rtnRen: false, // lcd_20201210
        rtnEndt: false // lcd_20201210
      },
      capCrcdGiroList: [
        { label: 'NA', value: 'NA' },
        { label: 'Credit Card', value: 'CARD' },
        { label: 'GIRO', value: 'GIRO' }
      ],
      payChqNoList: [
        { label: 'None', value: 'N' },
        { label: 'Optional', value: 'O' },
        { label: 'Mandatory', value: 'M' }
      ],
      helpList: false,
      helpListID: '',
      defPayBankList: [],
      newPaytMeth: false,
      loading: false,
      submitting: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    helpListValidate(field) {
      var IdList = []
      var i = 0
      if (field === 'defPayBankDesc') {
        for (i in this.defPayBankList) {
          IdList.push(this.defPayBankList[i].value)
        }
      }
      return IdList
    },
    async doFetch() {
      const apiURI = this.paytMethMenu.getPaytMeth
      if (apiURI) {
        this.loading = true
        try {
          const expand = { paytmeth: this.paytmeth }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // General
            this.paytMethForm.paytmeth = data.paytMeth.paytmeth
            this.paytMethForm.paytmethDesc = data.paytMeth.paytmethDesc
            this.paytMethForm.capCrcdGiro = data.paytMeth.capCrcdGiro
            this.paytMethForm.payChqNo = data.paytMeth.payChqNo
            this.paytMethForm.drawName = data.paytMeth.drawName
            this.paytMethForm.crcdNo = data.paytMeth.crcdNo
            this.paytMethForm.payBank = data.paytMeth.payBank
            this.paytMethForm.genCdPayt = data.paytMeth.genCdPayt
            this.paytMethForm.autoExtCvr = data.paytMeth.autoExtCvr
            this.paytMethForm.defPayBank = data.paytMeth.defPayBank
            this.paytMethForm.defPayBankDesc = data.paytMeth.defPayBankDesc
            this.paytMethForm.createdName = data.paytMeth.createdName
            this.paytMethForm.createdDate = data.paytMeth.createdDate
            this.paytMethForm.modifiedName = data.paytMeth.modifiedName
            this.paytMethForm.modifiedDate = data.paytMeth.modifiedDate
            this.paytMethForm.rtnRen = data.paytMeth.rtnRen // lcd_20201210
            this.paytMethForm.rtnEndt = data.paytMeth.rtnEndt // lcd_20201210
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSetList() {
      const getState = this.$store.state.paytMethParam
      this.defPayBankList = getState.defPayBankList
    },
    getHelpList(field) {
      this.helpListID = field
      this.helpList = true
    },
    doClose() {
      this.helpList = false
      this.busClsGrpHelpList = false
    },
    doAssign(Id, IdDesc) {
      if (this.helpListID === 'defPayBankList') {
        this.paytMethForm.defPayBank = Id.value3
        this.paytMethForm.defPayBankDesc = Id.value1
      }
    },
    doDefPayBank() {
      this.$validator.validate('defPayBankDesc').then((result) => {
        if (result) {
          const apiURI = this.paytMethMenu.getDefPayBank
          if (apiURI) {
            const expand = {
              defPayBank: this.paytMethForm.defPayBankDesc
            }
            this.$http
              .get(expandURI(apiURI, expand))
              .then((result) => {
                const { data } = result.data
                if (data) {
                  this.paytMethForm.defPayBank = data.defPayBank.defPayBank
                  this.paytMethForm.defPayBankDesc = data.defPayBank.defPayBankDesc
                }
              })
              .catch((err) => {
                this.paytMethForm.defPayBank = ''
                this.paytMethForm.defPayBankDesc = ''
                const { data } = err.response
                if (data) {
                  this.notify(data)
                }
              })
          }
        } else {
          this.paytMethForm.defPayBankDesc = ''
        }
      })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newPaytMeth) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
          // } else {
        }
      })
    },
    async doCreate() {
      const apiURI = this.paytMethMenu.createPaytMeth
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.paytMethForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'paytMethList' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.paytMethMenu.updatePaytMeth
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.paytMethForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'paytMethList' })
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.$router.push({ name: 'paytMethList' })
    }
  },
  computed: {
    paytmeth() {
      return this.$route.params.paytmeth
    },
    paytMethMenu() {
      return this.$store.state.paytMethParam.menu
    }
  },
  created() {
    this.doSetList()
    if (this.paytmeth === 'new') {
      this.newPaytMeth = true
    } else {
      this.doFetch()
    }
  },
  mixins: [MessageMixin],
  components: {
    HelpList
  }
}
</script>
